import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "cart_big"
};
const _hoisted_2 = {
  class: "cart_box"
};
const _hoisted_3 = {
  class: "add_show"
};
const _hoisted_4 = {
  class: "cart_box"
};
const _hoisted_5 = {
  key: 0,
  class: "goods_show"
};
const _hoisted_6 = {
  class: "goods_txt"
};
const _hoisted_7 = {
  class: "goods_info"
};
const _hoisted_8 = {
  class: "goods_buy"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_van_radio = _resolveComponent("van-radio");
  const _component_van_radio_group = _resolveComponent("van-radio-group");
  const _component_router_link = _resolveComponent("router-link");
  const _component_van_submit_bar = _resolveComponent("van-submit-bar");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_nav_bar, {
    title: "提交订单",
    "left-arrow": "",
    onClickLeft: $setup.goBack,
    fixed: "",
    placeholder: ""
  }, null, 8, ["onClickLeft"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "cart_title"
  }, "收货地址", -1)), _createVNode(_component_van_radio_group, {
    modelValue: $setup.addressID,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.addressID = $event)
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.addList, item => {
      return _openBlock(), _createBlock(_component_van_radio, {
        class: "add_list",
        key: item.id,
        name: item.id
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("dl", null, [_createElementVNode("dt", null, _toDisplayString(item.name) + " " + _toDisplayString(item.phone), 1), _createElementVNode("dd", null, _toDisplayString(item.address), 1)])])]),
        _: 2
      }, 1032, ["name"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
    to: "/address"
  }, {
    default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("添加地址")])),
    _: 1
  })])]), _createElementVNode("div", _hoisted_4, [_cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "cart_title"
  }, "商品列表", -1)), $setup.isShow ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.goodsList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "goods_list",
      key: item
    }, [_createElementVNode("div", {
      class: "goods_img",
      style: _normalizeStyle("background-image: url(" + item.img + ");")
    }, [_createVNode(_component_router_link, {
      to: "/goods/show?id=" + item.id
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
      _: 2
    }, 1032, ["to"])], 4), _createElementVNode("div", _hoisted_6, [_createElementVNode("dl", _hoisted_7, [_createElementVNode("dt", null, _toDisplayString(item.name), 1), _createElementVNode("dd", null, "规格：" + _toDisplayString(item.spec), 1), _createElementVNode("dd", null, "保质期：" + _toDisplayString(item.quality), 1)]), _createElementVNode("dl", _hoisted_8, [_createElementVNode("dt", null, [_createElementVNode("span", null, "￥" + _toDisplayString(item.price) + "/" + _toDisplayString(item.unit), 1), _createTextVNode("X" + _toDisplayString($setup.cartList[item.id].count), 1)]), _createElementVNode("dd", null, "￥" + _toDisplayString($setup.cartList[item.id].count * item.price), 1)])])]);
  }), 128))])) : _createCommentVNode("", true)])]), _createVNode(_component_van_submit_bar, {
    price: $setup.totalPrice,
    "button-text": $setup.submitBarText,
    onSubmit: $setup.onSubmit,
    placeholder: ""
  }, null, 8, ["price", "button-text", "onSubmit"])]);
}